<div class="label-container" #labelContainerEl>
  <div 
    #labelEl
    class="label" 
    [ngClass]="{
      'label--selected': (selectedLabel$ | async)?.id === label.id,
      'label--glow': label.pinGlow,
      'label--annotation': label.theme === 'annotation',
      'label--classic': label.theme === 'classic',
      'label--invert': isBackgroundDark,
      'label--studio': label.theme === 'studioNext',
      'label--context': label.theme === 'context'
    }">
    
    <!-- Pin -->
    <div 
      #pin
      class="label__pin"
      [ngClass]="{
        'label__pin--plus': label.pinType === labelPinType.Plus || (label.pinType === labelPinType.PlusMinus && (selectedLabel$ | async)?.id !== label.id),
        'label__pin--minus': label.pinType === labelPinType.Minus || (label.pinType === labelPinType.PlusMinus && (selectedLabel$ | async)?.id === label.id),
        'label__pin--draggable': pinDraggable
      }">
      <!-- Glow -->
      <div class="label__glow"></div>
    </div>

    <!-- Wire -->
    <div class="label__wire" [ngClass]="{'label__wire--collapse': isCollapsed || tagCollapsed || label.hideWire }" #wire></div>

    <!-- Tag -->
    <div 
      #tag
      class="label__tag"
      [ngClass]="{
        'label__tag--collapse': isCollapsed || tagCollapsed,
        'label__tag--draggable': tagDraggable
      }">

      <div class="label__header">
        <div class="label__title" #title [innerHTML]="label.title"></div>
        <div class="label__more" *ngIf="label.description && label.collapseDescription">
          <app-icon icon="caret-right"></app-icon>
        </div>
        
        <!-- Actions -->
        <div class="label__actions" appEventFence>
          <ng-content select="[label-actions]"></ng-content>
        </div>
      </div>

      <!-- Body -->
      <div 
        class="label__body" 
        *ngIf="label.description" 
        [ngClass]="{'label__body--collapse': isCollapsed || descriptionCollapsed}"
        [innerHTML]="label.description">
      </div>

      <!-- More -->
      <ng-content select="[label-more]"></ng-content>

    </div>
  </div>
</div>